import { defineMessages } from 'react-intl-next';

export default defineMessages({
	logo: {
		id: 'fabric.editor.ai.commandPalette.promptForm.logo',
		defaultMessage: 'Atlassian Intelligence Logo',
		description: 'Atlassian Intelligence logo alt text',
	},
});
